import React from 'react'
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import { useEffect } from 'react';
import "../styles/website.css"
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../components/Faqs';
import testimonial from "../assets/img/testimonial/t.webp"
import testimonial1 from "../assets/img/testimonial/t2.webp"
import testimonial2 from "../assets/img/testimonial/t3.webp"
import testimonial3 from "../assets/img/testimonial/t4.webp"
import { RiDoubleQuotesL } from "react-icons/ri";
import { RiDoubleQuotesR } from "react-icons/ri";
import { GoDash } from "react-icons/go";
import CaseStudy from '../components/CaseStudy';
import heroImg from "../assets/img/r1.avif"
import "../styles/digitalMarketing.css"
import { IoIosArrowRoundDown } from "react-icons/io";
import servicesImg from "../assets/img/s.jpg"
import ServicesCards from '../components/ServicesCards';
import { Banner } from '../components/Banner';
import AboutSection from '../components/AboutSection';
import CaseStudyGallery from '../components/CaseStudyGallery';
import Footer from '../components/Footer';
import ContentCreativeFAQs from '../components/CandCFAQS';

const ContentAndCreative = () => {

 
  

    const navigate = useNavigate();
  
  
  const handleContactBtn = () => {
    navigate("/get-in-touch")
  }
  

  return (
    <>
<section className="website-wrapper">
    

  <Banner/>
   
 <AboutSection/>
   
  <CaseStudyGallery/>

  <ContentCreativeFAQs/>



</section>


{/* 
<section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards">
    <div className="testimonial-card">
      <p className="quote">
        “The level of quality you delivered was amazing and I could not be any happier with it. 
         I truly appreciate your patience, the exceptional work you have done, the time taken to think this all through and the effort you put in to complete it and bring my vision to life. ”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="Tayla Ahrens"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Tayla Ahrens</p>
          <p className="client-title">Marketing Manager — Cairns & Mackay Airport</p>
        </div>
      </div>
    </div>

    <div className="testimonial-card">
      <p className="quote">
        “Working with Lalit has been a complete game-changer for my business! He’s not just a social media manager—he’s a true content strategist who understands how to elevate a brand’s presence online. ”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Will Perrin</p>
          <p className="client-title">Director — Computerman</p>
        </div>
      </div>
    </div>

        <div className="testimonial-card">
      <p className="quote">
        “We’ve been working with Mehtab and his team for three months now, and the results have been excellent. Their work has consistently added value to our business, and the investment has been well worth it. ”
      </p>
      <div className="client-info">
        <img
           src={testimonial2}
          alt="Tayla Ahrens"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Tayla Ahrens</p>
          <p className="client-title">Marketing Manager — Cairns & Mackay Airport</p>
        </div>
      </div>
    </div>

    <div className="testimonial-card">
      <p className="quote">
        “Working with Kolja on my SEO gig was marvellous! At this point I can't say anything about the results since those take time, but the collaboration so far was amazing!”
      </p>
      <div className="client-info">
        <img
           src={testimonial3}
          alt="Will Perrin"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Will Perrin</p>
          <p className="client-title">Director — Computerman</p>
        </div>
      </div>
    </div>
  </div>
</section>
*/}

<section className="booking-wrapper">
  <div className="booking-content">
    <h3>Let's get to work</h3>
    <p>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>
</>

  )
}

export default ContentAndCreative